import { render, staticRenderFns } from "./topo-detect-point.vue?vue&type=template&id=9762ecd8&"
import script from "./topo-detect-point.vue?vue&type=script&lang=ts&"
export * from "./topo-detect-point.vue?vue&type=script&lang=ts&"
import style0 from "./topo-detect-point.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports